const COOKIE_NAME = 'cookie_consent';
const MAX_AGE = 60 * 60 * 24 * 365; // 1 year

export type CookieConsentValue = 'accepted' | 'declined';

const listeners = new Set<() => void>();

export function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function getCookieConsent(): CookieConsentValue | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  if (!match) return null;
  const value = decodeURIComponent(match[1]);
  if (value === 'accepted' || value === 'declined') return value;
  return null;
}

export function setCookieConsent(value: CookieConsentValue): void {
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; path=/; max-age=${MAX_AGE}; samesite=lax`;
  listeners.forEach((cb) => cb());
}

export function clearCookieConsent(): void {
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; samesite=lax`;
  listeners.forEach((cb) => cb());
}
